import script from "./UsuarioPerfil.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioPerfil.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioPerfil.vue?vue&type=style&index=0&id=8e9c140c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e9c140c"]])

export default __exports__